document.addEventListener("DOMContentLoaded", function () {
  const picker = document.querySelector("[data-variant-picker]");
  if (!picker) return;

  const addBtn = document.querySelector(".add-to-cart-btn");
  const dynamicButtons = document.querySelector(".dynamic-payment-buttons");
  const errorBox = picker.querySelector("[data-variant-error-inline]");

  function getMissingOptions() {
    const selectors = Array.from(
      document.querySelectorAll("[data-single-option-selector]")
    );

    const missing = [];

    selectors.forEach((el) => {
      const nameMatch = el.name.match(/options\[(.*)\]/);
      const name = nameMatch ? nameMatch[1] : "Option";

      if (el.tagName === "SELECT" && (el.value === "" || el.value === null)) {
        missing.push(name);
      }

      if (el.type === "radio") {
        const checked = document.querySelector(`input[name="${el.name}"]:checked`);
        if (!checked) missing.push(name);
      }
    });

    return [...new Set(missing)];
  }

  function showError(missing) {
    const message =
      missing.length === 1
        ? `Select Your ${missing[0]}`
        : `Select Your ${missing.join(", ")}`;

    errorBox.textContent = message;
    errorBox.classList.remove("hidden");

    picker.classList.add("product-variant-picker-error");

    // Scroll into view
    picker.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function clearError() {
    errorBox.textContent = "";
    errorBox.classList.add("hidden");
    picker.classList.remove("product-variant-picker-error");
  }

  function validateSelection(showUI = true) {
    const missing = getMissingOptions();
    const invalid = missing.length > 0;

    if (invalid) {
      if (showUI) showError(missing);
      return false;
    }

    if (showUI) clearError();
    return true;
  }

  function blockButtonClick(e) {
    if (!validateSelection(true)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }

  // INTERCEPT ADD TO CART
  if (addBtn) {
    addBtn.addEventListener("click", blockButtonClick, true);
  }

  // INTERCEPT BUY NOW / SHOP PAY / GOKWIK
  if (dynamicButtons) {
    dynamicButtons.addEventListener("click", blockButtonClick, true);
  }

  // When user changes an option → revalidate and enable/disable buttons accordingly
  document.querySelectorAll("[data-single-option-selector]").forEach((el) => {
    el.addEventListener("change", function () {
      if (validateSelection(false)) {
        addBtn?.removeAttribute("disabled");
        dynamicButtons?.classList.remove("dynamic-payment-buttons--disabled");
      } else {
        addBtn?.setAttribute("disabled", "disabled");
        dynamicButtons?.classList.add("dynamic-payment-buttons--disabled");
      }
    });
  });

  // Initial lock
  if (addBtn) addBtn.setAttribute("disabled", "disabled");
  if (dynamicButtons)
    dynamicButtons.classList.add("dynamic-payment-buttons--disabled");
});
